<div class="modal-body width-600 height-800">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">
      Dialogfragen
    </h5>
    <div class="content">
      <ng-container *ngFor="let data of responseData;let i = index">
        <div>
          <ng-container *ngIf="data.df_enmIdent_DialogFrageTyp === 1">
            <exg-input [(ngModel)]="data.deValue" type="text" [caption]="data.dfText" [required]="data.dfPflichtfeld"
                       hintText="*">
            </exg-input>
          </ng-container>
          <ng-container *ngIf="data.df_enmIdent_DialogFrageTyp === 2">
            <exg-textarea [(ngModel)]="data.deValue" [caption]="data.dfText" [required]="data.dfPflichtfeld"
                          hintText="*"></exg-textarea>
          </ng-container>
          <ng-container *ngIf="data.df_enmIdent_DialogFrageTyp === 3">
            <exg-input [(ngModel)]="data.deValue" type="text" [caption]="data.dfText" [required]="data.dfPflichtfeld"
                       hintText="*">
            </exg-input>
          </ng-container>
          <ng-container *ngIf="data.df_enmIdent_DialogFrageTyp === 4">
            <exg-input [(ngModel)]="data.deValue" type="text" [caption]="data.dfText" [required]="data.dfPflichtfeld"
                       hintText="*">
            </exg-input>
          </ng-container>
          <ng-container *ngIf="data.df_enmIdent_DialogFrageTyp === 5">
            <exg-input [(ngModel)]="data.deValue" type="date" [caption]="data.dfText" [required]="data.dfPflichtfeld"
                       hintText="*">
            </exg-input>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getResource('Cancel')}}
      </button>
      <button (click)="save()" class="md-btn">
        {{getResource('Save')}}
      </button>
    </div>
  </div>
</div>
